import { render } from "./Protocollo.vue?vue&type=template&id=0b9e67ae"
import script from "./Protocollo.vue?vue&type=script&lang=js"
export * from "./Protocollo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francescoscialacqua/Sviluppo/emmet.client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__